export default "__VITE_ASSET__CvBKLstH__"